var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M61.577 42.241 40.015 8.19A9.78 9.78 0 0 0 32.009 4c-3.176 0-6.192 1.548-8.086 4.27L2.467 42.188c-2.722 3.896-3.229 8.566-1.334 12.169C3 57.96 6.923 60.014 11.834 60.014h40.35c4.937 0 8.833-2.054 10.7-5.657 1.869-3.603 1.362-8.246-1.307-12.116M29.34 20.011c0-1.467 1.201-2.668 2.669-2.668s2.668 1.201 2.668 2.669v16.011c0 1.468-1.2 2.67-2.668 2.67a2.677 2.677 0 0 1-2.669-2.67zm2.669 32.024a4 4 0 0 1-4.003-4.003 4 4 0 0 1 4.003-4.003 4 4 0 0 1 4.003 4.003 4 4 0 0 1-4.003 4.003"
  })));
};
export default SvgAlert;